/* src/app/module/service-advisors/add-service-advisor/service-advisor-certificates/service-advisor-certificates.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
.custom-upload-button {
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 43px;
}
.remove-button {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 14px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(8, 12, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-bar {
  width: 100px;
  height: 10px;
  background-color: black;
  animation: load 2s infinite;
}
@keyframes load {
  0% {
    width: 0;
  }
  100% {
    width: 100px;
  }
}
/*# sourceMappingURL=service-advisor-certificates.component-G7RQOE4D.css.map */
